var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.83398H4.66634C2.82539 1.83398 1.33301 3.32637 1.33301 5.16732V11.834C1.33301 13.6749 2.82539 15.1673 4.66634 15.1673H11.333C13.174 15.1673 14.6663 13.6749 14.6663 11.834V5.16732C14.6663 3.32637 13.174 1.83398 11.333 1.83398Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 8.0802C10.7491 8.63503 10.6543 9.20168 10.396 9.69954C10.1376 10.1974 9.72889 10.6011 9.22788 10.8533C8.72687 11.1055 8.1591 11.1933 7.60532 11.1042C7.05155 11.015 6.53997 10.7536 6.14336 10.357C5.74674 9.96036 5.48528 9.44878 5.39618 8.89501C5.30707 8.34124 5.39484 7.77346 5.64701 7.27245C5.89919 6.77144 6.30292 6.36269 6.80079 6.10436C7.29865 5.84603 7.8653 5.75126 8.42013 5.83353C8.98608 5.91746 9.51003 6.18118 9.91459 6.58574C10.3192 6.9903 10.5829 7.51425 10.6668 8.0802Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.83398H11.6737",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7653a49c8f10cfa88ca2da2eb8652423.svg";
export { ForwardRef as ReactComponent };